import {
  HivebriteSegmentType,
} from '…/app/w/workspace/audiences/audience/members/hivebrite/types.js';

import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import SEARCH_INTEGRATION_LIST from './searchIntegrationList.gql';

type SearchIntegrationListResult = {
  searchIntegrationList: {
    results: { id: string, name: string }[],
    searchQuery?: string,
  },
};

export function searchIntegrationList(
  integrationId: ObjectId,
  listType: HivebriteSegmentType,
  searchQuery?: string,
) {
  return gqlOperation<SearchIntegrationListResult>(SEARCH_INTEGRATION_LIST, {
    integrationId,
    listType: listType.toUpperCase(),
    searchQuery,
  })
    .then((data) => {
      if (!data) throw data;
      return data.searchIntegrationList;
    });
}
